module.exports = __webpack_public_path__ + "static/media/29DUNON7.d606547c.jpg";